function updateTimer(timerElement, endTime) {
  const timeLeft = endTime - Date.now();

  if (timeLeft <= 0) {
    timerElement.innerHTML = "Sale Ended!";
    return;
  }

  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  // Add leading zero if the number is less than 10
  const formatTime = (num) => (num < 10 ? "0" + num : num);

  timerElement.innerHTML = `<div style="display: none; text-align: center; margin-right:1px;">
                              <div class="thetime">${formatTime(days)}d</div>
                            </div>
                            <div style="display: inline-block; text-align: center; margin-right:1px;">
                              <div class="thetime">${formatTime(hours)}h</div>
                            </div>
                            <div style="display: inline-block; text-align: center; margin-right:1px;">
                              <div class="thetime">${formatTime(minutes)}m</div>
                            </div>
                            <div style="display: inline-block; text-align: center;">
                              <div class="thetime">${formatTime(seconds)}s</div>
                            </div>`;
}

const timerWraps = document.querySelectorAll(".sale-timer[data-end]");

function updateAllTimers() {
  const now = Date.now();

  timerWraps.forEach((wrap) => {
    const start = Number(wrap.dataset.start) * 1000;
    const end = Number(wrap.dataset.end) * 1000;
    const live = now >= start && now < end;

    // Show only between start and end time
    wrap.style.display = live ? "" : "none";
    if (live) updateTimer(wrap.querySelector(".offertimer"), end);
  });
}

// Initial call, then update every second
updateAllTimers();
setInterval(updateAllTimers, 1000);